import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function Electronics() {
  const { addToCart } = useCart();

  const electronicsProducts = [
    {
      id: 'elec1',
      name: 'Smartphone Pro Max',
      price: 899,
      originalPrice: 1199,
      image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'Latest smartphone with advanced camera and long battery life'
    },
    {
      id: 'elec2',
      name: 'Laptop Ultra',
      price: 1299,
      originalPrice: 1699,
      image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'High-performance laptop for work and gaming'
    },
    {
      id: 'elec3',
      name: 'Wireless Headphones',
      price: 149,
      originalPrice: 199,
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'Noise-cancelling wireless headphones'
    },
    {
      id: 'elec4',
      name: 'Smart Watch',
      price: 299,
      originalPrice: 399,
      image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'Fitness tracking smartwatch with health monitoring'
    },
    {
      id: 'elec5',
      name: '4K Smart TV',
      price: 599,
      originalPrice: 799,
      image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: '55-inch 4K Ultra HD Smart TV'
    },
    {
      id: 'elec6',
      name: 'Gaming Console',
      price: 449,
      originalPrice: 499,
      image: 'https://images.unsplash.com/photo-1486401899868-0e435ed85128?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'Next-gen gaming console with wireless controller'
    },
    {
      id: 'elec7',
      name: 'Bluetooth Speaker',
      price: 79,
      originalPrice: 99,
      image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: 'Portable waterproof bluetooth speaker'
    },
    {
      id: 'elec8',
      name: 'Tablet Pro',
      price: 399,
      originalPrice: 549,
      image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Electronics',
      description: '10-inch tablet with stylus support'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Electronics</h1>
          <p>Latest gadgets and tech innovations</p>
        </div>
        
        <div className="product-grid">
          {electronicsProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                  <span className="current-price">${product.price}</span>
                  <span className="original-price">${product.originalPrice}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Electronics; 